<app-nav></app-nav>
<app-side-nav></app-side-nav>
<div class="container">
	<router-outlet></router-outlet>
</div>
<p class="vertical-text">{{titleService.title}}</p>
